import { render, staticRenderFns } from "./PlusDisabled.vue?vue&type=template&id=41a58d44&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a58d44')) {
      api.createRecord('41a58d44', component.options)
    } else {
      api.reload('41a58d44', component.options)
    }
    module.hot.accept("./PlusDisabled.vue?vue&type=template&id=41a58d44&", function () {
      api.rerender('41a58d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/PlusDisabled.vue"
export default component.exports